// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.container[data-v-45b493a9] {\n  width: 60vw;\n  margin: auto;\n  background-color: #f2f2f2;\n}\n.text-left[data-v-45b493a9] {\n  text-align: left;\n  margin-left: 2vw;\n  margin-top: 3vh;\n}\n.text-left-note[data-v-45b493a9] {\n  text-align: left;\n}\n", ""]);
// Exports
module.exports = exports;
